<template>
  <div>
    <h3 class="h3" v-text="translate('lblGrowingRegionHeadline')"></h3>

    <div class="form-row row">
      <div class="col-4 col-m-2 mb-s-3 mb-m-0">
        <slot name="postal"></slot>
      </div>
      <div class="col-8 col-m-4">
        <slot name="place"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrowingRegion',
};
</script>
